export default __webpack_public_path__ + "static/media/logo512.38417fc0.png";